export class MediaSlider {
	/**
	 * Initialize a new Sections element
	 *
	 * @param {HTMLElement} node - the node that contains the root scrolling element
	 * @param {object} opts -
	 */
	constructor( node, opts ) {
		this.node = node;
		this.opts = {
			back: '.media-slider__nav-btn--prev',
			forward: '.media-slider__nav-btn--next',
			content: '.media-slider__slides',
			items: '.media-slider__slides > *',
			...opts,
		};

		if ( ! this.node ) {
			return;
		}

		this.back = this.node.querySelector( this.opts.back );
		this.forward = this.node.querySelector( this.opts.forward );
		this.content = this.node.querySelector( this.opts.content );
		this.items = this.node.querySelectorAll( this.opts.items );

		window.addEventListener( 'resize', this.setState.bind( this ) );
		this.content.addEventListener( 'scroll', this.setState.bind( this ) );

		if ( this.back ) {
			this.back.addEventListener( 'click', this.backIndex.bind( this ) );
		}

		if ( this.forward ) {
			this.forward.addEventListener( 'click', this.forwardIndex.bind( this ) );
		}

		this.setIndex( 0 );
		this.setState();
	}

	setState() {
		const firstItem = this.items[ 0 ];
		const lastItem = this.items[ this.items.length - 1 ];

		if ( this.back ) {
			if ( firstItem.offsetLeft - this.content.scrollLeft >= 0 ) {
				// first item is is view
				this.back.disabled = true;
			} else {
				// first item is outside the scroll area
				this.back.removeAttribute( 'disabled' );
			}
		}

		if ( this.forward ) {
			if ( this.content.scrollLeft + this.content.offsetWidth >= lastItem.offsetLeft + lastItem.offsetWidth - 1 ) {
				// the last item is fully in view
				this.forward.disabled = true;
			} else {
				// last item is outside the scroll area
				this.forward.removeAttribute( 'disabled' );
			}
		}
	}

	getIndex() {
		const offset = this.getPaddingOffset();
		const distances = [ ...this.items ].map( ( item ) => Math.abs( item.offsetLeft - this.content.scrollLeft - offset ) );

		return distances.indexOf( Math.min( ...distances ) );
	}

	getPaddingOffset() {
		return Math.max( parseInt( getComputedStyle( this.content ).paddingLeft, 10 ), 0 );
	}

	setIndex( index, behavior = 'smooth' ) {
		if ( index <= this.items.length ) {
			const left = this.items[ index ].offsetLeft - this.getPaddingOffset();

			this.content.scrollTo( {
				left: Math.max( 0, left ),
				behavior,
			} );
		}
	}

	backIndex() {
		this.setIndex( Math.round( Math.max( this.getIndex() - 1, 0 ) ) );
	}

	forwardIndex() {
		this.setIndex( Math.round( Math.min( this.getIndex() + 1, this.items.length - 1 ) ) );
	}
}

document.querySelectorAll( '.media-slider' ).forEach( ( node ) => {
	new MediaSlider( node, { ...node.dataset } );
} );
